export enum FirestoreCollections {
  OFFERS = 'offers',
  COMPANIES = 'companies',
  WORKERS = 'workers',
  USERS = 'users',
  SUBMISSIONS = 'submissions',
}
